import types from "./actionTypes";
import { dealWithNetworks } from '../../undoredo/actions'
import * as selectors from "./selectors";
import { constructIds } from "../../../config/common";



export const addNetwork = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithNetworks(payload, 'add'))

	dispatch({
		type: types.ADD_NETWORK,
		payload,
	})
};


export const editNetwork = (payload, noUndoRedo) => (dispatch) => {
	if (noUndoRedo != true)
		dispatch(dealWithNetworks(payload, 'edit'))

	dispatch({
		type: types.EDIT_NETWORK,
		payload,
	})
};

export const deleteNetwork = (payload, noUndoRedo) => (dispatch, getState) => {

	if (noUndoRedo != true)
		dispatch(dealWithNetworks(payload, 'delete'))

	dispatch({ type: types.DELETE_NETWORK, payload })
};

export const updateFullNetworks = (networks) => ({
	type: types.UPDATE_FULL_NETWORKS,
	payload: networks
})


export const resetNetworks = (networks) => ({
	type: types.RESET_NETWORKS,
	payload: networks
})